import { PageController } from '@client/components/_core/layout/PageController';
import { ProductEdit } from '@client/components/products-v2/ProductEdit';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/console/$orgId/configuration/claims-products/products-v2/add')({
    staticData: {
        presentation: 'overlay',
        metadata: {
            title: 'New product',
        },
    },
    component: RouteComponent,
});

function RouteComponent() {
    return (
        <PageController route={Route}>
            <ProductEdit action={['add']} />
        </PageController>
    );
}
